export default __webpack_public_path__ + "static/media/Weather4.5f3642cc.png";